import React from 'react';
//scss
import './ProjectB.scss';
//icons
import Sun from '../Icons/sun';

class ProjectB extends React.Component {
  constructor() {
    super();
    this.backgroundRef = React.createRef();
    this.underlineRef = React.createRef();
  }
  onHoverOn = () => {
    const isFirefox = typeof InstallTrigger !== 'undefined';
    if (isFirefox === false) {
      const background = this.backgroundRef.current;
      background.classList.toggle('background_hover');
    }
    const underline = this.underlineRef.current;
    underline.classList.toggle('underline_hover');
  };

  onHoverOut = () => {
    const isFirefox = typeof InstallTrigger !== 'undefined';
    if (isFirefox === false) {
      const background = this.backgroundRef.current;
      background.classList.toggle('background_hover');
    }
    const underline = this.underlineRef.current;
    underline.classList.toggle('underline_hover');
  };
  render() {
    return (
      <div className="ProjectB_wrapper">
        <div className="ProjectB">
          <div className="ProjectB_background" ref={this.backgroundRef}></div>
          <div
            className="ProjectB_content"
            onMouseEnter={this.onHoverOn}
            onMouseLeave={this.onHoverOut}
          >
            <Sun />
            <div className="ProjectB_content_Text">
              <div className="ProjectB_content_Text_title">
                SUNDIAL
                <div
                  className="ProjectB_content_Text_title_underline"
                  ref={this.underlineRef}
                ></div>
              </div>
              <div className="ProjectB_content_Text_description">
                Web utility for landscape Architects to automate the process of
                sun study creation <span>(OFFLINE)</span>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default ProjectB;
